import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const CellDetail = lazyRouteComponent(() => import('@/widgets/cell-detail'), 'CellDetail')

export const Route = createFileRoute('/cells/$cellId')({
  component: CellPage,
})

function CellPage() {
  const { cellId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={cellId} />
      <CellDetail cellId={cellId} />
    </>
  )
}
